import TableNamesAdd from "./TableNamesAdd";
import CloseSave from "../../../design/close";


export default function AddNamesToNames ({names, setClose, namesList, setNamesList}) {

    return (
        <div className="add-names-to-names-inDocket">
            <p> הוסף שמות </p>

            <CloseSave 
            fs="15pt" 
            setClose={setClose}
            bc="rgb(0, 30, 54)" 
            c="wheat"
            hbc="rgba(127, 214, 255)"
            />

            <CloseSave 
            fs="15pt" 
            setClose={setClose}
            bc="rgb(0, 30, 54)" 
            c="wheat"
            hbc="rgba(127, 214, 255)"
            left={false}
            />

            <div className={"add-names-to-names-inDocket-data"}>
                <TableNamesAdd 
                names={names}
                namesList={namesList}
                setNamesList={setNamesList}
                />
            </div>

        </div>
    )
}